module.exports = __webpack_public_path__ + "static/media/ic_score.69691769.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ic_score.svg
// module id = 875
// module chunks = 0